import React from "react"
import { Helmet } from "react-helmet"
import useSiteMetadata from "./SiteMetadata"
import { withPrefix } from "gatsby"
import { ThemeProvider } from "styled-components"
import theme from "../utils/theme"
import "../i18n"
import Header from "./Header"
import { Footer, FooterMobile } from "../components/Footer"
import { BreakpointProvider, Breakpoint } from "react-socks"
import { Flex, Box } from "./Flex"

const TemplateWrapper = ({ children, secondary, credentials }) => {
  const { title, description } = useSiteMetadata()
  viewPortController()
  return (
    <ThemeProvider theme={theme}>
      <BreakpointProvider>
        <Helmet>
          <html lang="en" />
          <title>{title}</title>
          <meta name="description" content={description} />

          <link
            rel="apple-touch-icon"
            sizes="180x180"
            href={`${withPrefix("/")}img/favicon.ico`}
          />
          <link
            rel="icon"
            type="image/png"
            href={`${withPrefix("/")}img/favicon.ico`}
            sizes="32x32"
          />
          <link
            rel="icon"
            type="image/png"
            href={`${withPrefix("/")}img/favicon.ico`}
            sizes="16x16"
          />

          <link
            rel="mask-icon"
            href={`${withPrefix("/")}img/favicon.svg`}
            color="#ff4400"
          />
          <meta name="theme-color" content="#fff" />

          <meta property="og:type" content="business.business" />
          <meta property="og:title" content={title} />
          <meta property="og:url" content="/" />
          <meta
            property="og:image"
            content={`${withPrefix("/")}img/og-image.png`}
          />
        </Helmet>
        <Header secondary={secondary} credentials={credentials} />
        <div>{children}</div>
        {/*Do not remove this code, this solves the unknown problem with the Footer*/}
        <Breakpoint medium down>
          <Flex><Box></Box></Flex>
        </Breakpoint>
        {/**/}
        <Breakpoint medium down>
          <FooterMobile secondary={secondary} />
        </Breakpoint>
        <Breakpoint large up>
          <Footer secondary={secondary} />
        </Breakpoint>
      </BreakpointProvider>
    </ThemeProvider>
  )
}

const viewPortController = () => {
  if (typeof window === "undefined") {
    return
  }
  let vh = window.innerHeight * 0.01
  let vw = window.innerWidth * 0.01

  let isPortrait = vh > vw
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty("--vh", `${vh}px`)
  document.documentElement.style.setProperty(
    "--viewPortHeigth",
    window.innerHeight
  )

  // We listen to the resize event
  window.addEventListener("resize", () => {
    let vh = window.innerHeight * 0.01
    let vw = window.innerWidth * 0.01
    let currentPortrait = vh > vw
    // If it is changed from portrait to landscape or vice versa, otherwise do not change the window size
    if (isPortrait !== currentPortrait) {
      isPortrait = currentPortrait
      document.documentElement.style.setProperty("--vh", `${vh}px`)
      document.documentElement.style.setProperty(
        "--viewPortHeigth",
        window.innerHeight
      )
    }
  })
}

export default TemplateWrapper
